import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { httpGetFullRejections } from '@/features/host-review/http/host-review.http'
import { QUERY_KEYS } from '@/query-client'

export const FULL_REJECTIONS_PER_PAGE = 25

/** The read-only list of shoots where the host removed every photo. */
export const useGetFullRejections = (params: {
	page: number
	perPage?: number
}) =>
	useQuery({
		queryKey: [
			QUERY_KEYS.HOST_REVIEW_FULL_REJECTIONS,
			params.page,
			params.perPage ?? FULL_REJECTIONS_PER_PAGE
		],
		queryFn: () =>
			httpGetFullRejections({
				page: params.page,
				perPage: params.perPage ?? FULL_REJECTIONS_PER_PAGE
			}),
		// Paging a read-only log shouldn't blank the table between pages.
		placeholderData: keepPreviousData,
		retry: false
	})
